// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header {
    position: fixed;
    top: -100px;
    width: 100%;
    background-color: #fff;
    transition: top 0.3s;
    @media screen and (max-width: 600px) {
      top: 0;
      box-sizing: border-box;
      width: 100%;
    } 
  }
  
  #header.show {
    top: 0;
    z-index: 9;
   box-sizing: border-box;
   width: 100%;
  }
  .main-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 50px;
    width: 1150px;
      margin: 0 auto;
      @media screen and (max-width: 600px) {
        width: 100%;
        padding: 0 ;
        display: flex;
        justify-content: space-around;
      }
  
  }
  #primary-menu {
    display: flex;
    @media screen and (max-width: 600px) {
      flex-direction: column;
      display: flex;
    } 
  }
  .menu-item {
    list-style-type: none;
    color: #1e1c1a !important;
    font-size: 17px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 30px;
    position: relative;
    padding: 5px 20px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    cursor: pointer;
  }
  a {
    text-decoration: none;
    color: #1e1c1a !important;
    display: flex;
    align-items: center;
    
  }
  
  /* Add this CSS to your Header.css file */
  .drop__menu-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 1;
    padding: 10px;
    width: 137px;
  }
  
  .drop__menu-header.show {
    display: block;
    width: 100%;
  }
  
  .drop__menu-header li {
    padding: 8px 16px;
  }
  
  .rotate-icon-header {
    transition: transform 0.3s ease;
  }
  
  .drop__menu-header li:hover {
    background-color: #f5f5f5;
  }
  @media screen and (min-width: 601px) {
    .menu-button {
      display: none;
    }
  }
  
  @media screen and (max-width: 600px) {
    .bar {
      background-color: #000;
      height: 3px;
      width: 25px;
      margin: 4px 0;
      transition: 0.4s;
    }
    .header--menu {
      position: fixed;
      top: 0;
      left: -250px;
      width: 250px;
      height: 100vh;
      background-color: #fff;
      padding-top: 80px;
      transition: left 0.3s ease;
      color: #000;
      display: flex;
      flex-direction: column;
    }
  
    .menu-open .header--menu {
      left: 0;
      display: flex;
      flex-direction: column;
    }
    .menu-button {
      display: flex;
      flex-direction: column;
      cursor: pointer;
      padding: 10px;
      z-index: 1;
      align-items: flex-end;
      margin-right: 10px;
    }
    .menu-open .header--menu__title {
      display: block;
      margin-right: 24px;
      color: #000;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 2px;
      line-height: 21px;
    }
  
    .menu-button .bar {
      background-color: #d01818;
      height: 3px;
      width: 25px;
      margin: 4px 0;
      transition: 0.4s;
      display: flex;
    }
    .menu-button .bar:nth-child(3) {
      background-color: #d01818;
      height: 3px;
      width: 20px;
      margin: 4px 0;
      transition: 0.4s;
      display: flex;
    }
  
    .menu-open .bar:nth-child(1) {
      transform: rotate(-45deg) translate(-9px, 6px);
    }
  
    .menu-open .bar:nth-child(2) {
      transform: rotate(45deg) translate(-2px, 1px);
      
    }
  
    .menu-open .bar:nth-child(3) {
      opacity: 0;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,oBAAoB;IACpB;MACE,MAAM;MACN,sBAAsB;MACtB,WAAW;IACb;EACF;;EAEA;IACE,MAAM;IACN,UAAU;GACX,sBAAsB;GACtB,WAAW;EACZ;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,aAAa;MACX,cAAc;MACd;QACE,WAAW;QACX,WAAW;QACX,aAAa;QACb,6BAA6B;MAC/B;;EAEJ;EACA;IACE,aAAa;IACb;MACE,sBAAsB;MACtB,aAAa;IACf;EACF;EACA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;;EAErB;;EAEA,yCAAyC;EACzC;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,sBAAsB;IACtB,0CAA0C;IAC1C,UAAU;IACV,aAAa;IACb,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,sBAAsB;MACtB,WAAW;MACX,WAAW;MACX,aAAa;MACb,gBAAgB;IAClB;IACA;MACE,eAAe;MACf,MAAM;MACN,YAAY;MACZ,YAAY;MACZ,aAAa;MACb,sBAAsB;MACtB,iBAAiB;MACjB,0BAA0B;MAC1B,WAAW;MACX,aAAa;MACb,sBAAsB;IACxB;;IAEA;MACE,OAAO;MACP,aAAa;MACb,sBAAsB;IACxB;IACA;MACE,aAAa;MACb,sBAAsB;MACtB,eAAe;MACf,aAAa;MACb,UAAU;MACV,qBAAqB;MACrB,kBAAkB;IACpB;IACA;MACE,cAAc;MACd,kBAAkB;MAClB,WAAW;MACX,eAAe;MACf,iBAAiB;MACjB,mBAAmB;MACnB,iBAAiB;IACnB;;IAEA;MACE,yBAAyB;MACzB,WAAW;MACX,WAAW;MACX,aAAa;MACb,gBAAgB;MAChB,aAAa;IACf;IACA;MACE,yBAAyB;MACzB,WAAW;MACX,WAAW;MACX,aAAa;MACb,gBAAgB;MAChB,aAAa;IACf;;IAEA;MACE,8CAA8C;IAChD;;IAEA;MACE,6CAA6C;;IAE/C;;IAEA;MACE,UAAU;IACZ;EACF","sourcesContent":["#header {\n    position: fixed;\n    top: -100px;\n    width: 100%;\n    background-color: #fff;\n    transition: top 0.3s;\n    @media screen and (max-width: 600px) {\n      top: 0;\n      box-sizing: border-box;\n      width: 100%;\n    } \n  }\n  \n  #header.show {\n    top: 0;\n    z-index: 9;\n   box-sizing: border-box;\n   width: 100%;\n  }\n  .main-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 50px;\n    width: 1150px;\n      margin: 0 auto;\n      @media screen and (max-width: 600px) {\n        width: 100%;\n        padding: 0 ;\n        display: flex;\n        justify-content: space-around;\n      }\n  \n  }\n  #primary-menu {\n    display: flex;\n    @media screen and (max-width: 600px) {\n      flex-direction: column;\n      display: flex;\n    } \n  }\n  .menu-item {\n    list-style-type: none;\n    color: #1e1c1a !important;\n    font-size: 17px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 30px;\n    position: relative;\n    padding: 5px 20px;\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    cursor: pointer;\n  }\n  a {\n    text-decoration: none;\n    color: #1e1c1a !important;\n    display: flex;\n    align-items: center;\n    \n  }\n  \n  /* Add this CSS to your Header.css file */\n  .drop__menu-header {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background-color: #fff;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n    z-index: 1;\n    padding: 10px;\n    width: 137px;\n  }\n  \n  .drop__menu-header.show {\n    display: block;\n    width: 100%;\n  }\n  \n  .drop__menu-header li {\n    padding: 8px 16px;\n  }\n  \n  .rotate-icon-header {\n    transition: transform 0.3s ease;\n  }\n  \n  .drop__menu-header li:hover {\n    background-color: #f5f5f5;\n  }\n  @media screen and (min-width: 601px) {\n    .menu-button {\n      display: none;\n    }\n  }\n  \n  @media screen and (max-width: 600px) {\n    .bar {\n      background-color: #000;\n      height: 3px;\n      width: 25px;\n      margin: 4px 0;\n      transition: 0.4s;\n    }\n    .header--menu {\n      position: fixed;\n      top: 0;\n      left: -250px;\n      width: 250px;\n      height: 100vh;\n      background-color: #fff;\n      padding-top: 80px;\n      transition: left 0.3s ease;\n      color: #000;\n      display: flex;\n      flex-direction: column;\n    }\n  \n    .menu-open .header--menu {\n      left: 0;\n      display: flex;\n      flex-direction: column;\n    }\n    .menu-button {\n      display: flex;\n      flex-direction: column;\n      cursor: pointer;\n      padding: 10px;\n      z-index: 1;\n      align-items: flex-end;\n      margin-right: 10px;\n    }\n    .menu-open .header--menu__title {\n      display: block;\n      margin-right: 24px;\n      color: #000;\n      font-size: 18px;\n      font-weight: bold;\n      letter-spacing: 2px;\n      line-height: 21px;\n    }\n  \n    .menu-button .bar {\n      background-color: #d01818;\n      height: 3px;\n      width: 25px;\n      margin: 4px 0;\n      transition: 0.4s;\n      display: flex;\n    }\n    .menu-button .bar:nth-child(3) {\n      background-color: #d01818;\n      height: 3px;\n      width: 20px;\n      margin: 4px 0;\n      transition: 0.4s;\n      display: flex;\n    }\n  \n    .menu-open .bar:nth-child(1) {\n      transform: rotate(-45deg) translate(-9px, 6px);\n    }\n  \n    .menu-open .bar:nth-child(2) {\n      transform: rotate(45deg) translate(-2px, 1px);\n      \n    }\n  \n    .menu-open .bar:nth-child(3) {\n      opacity: 0;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
